import {IconProps} from './types';

const Waze = ({fill = 'currentColor', className, width = 20, height = 20}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden
    >
        <path d="M11.1831 17.025C11.3331 18.1166 12.2664 18.95 13.3914 18.95C14.6248 18.95 15.6248 17.9583 15.6248 16.725C15.6248 16.35 15.5331 16 15.3748 15.7" />
        <path d="M9.28317 16.9918C9.8165 17.0168 10.3748 17.0334 10.9582 17.0334C15.3748 17.0334 18.9582 13.4501 18.9582 9.03345C18.9582 4.61678 15.3748 1.03345 10.9582 1.03345C6.5415 1.03345 2.9665 4.61678 2.9665 9.03345C2.9665 10.7668 2.9665 11.9084 1.0415 12.4168C1.78317 14.3001 2.97484 15.5168 4.8915 16.2251" />
        <path d="M14.6586 10.5583C14.1002 11.5583 13.0336 12.2417 11.8002 12.2417C10.5752 12.2417 9.50023 11.5583 8.94189 10.5583" />
        <path d="M5.48353 18.3084C5.06686 17.8917 4.8252 17.3167 4.8252 16.725C4.8252 16.1334 5.06686 15.5667 5.48353 15.15C5.9002 14.725 6.47519 14.4917 7.06686 14.4917C7.65853 14.4917 8.2252 14.725 8.64186 15.15C9.06686 15.5667 9.3002 16.1334 9.3002 16.725C9.3002 17.3167 9.06686 17.8917 8.64186 18.3084C8.2252 18.725 7.65853 18.9667 7.06686 18.9667C6.47519 18.9667 5.9002 18.725 5.48353 18.3084Z" />
        <path d="M14.6667 7.50008C14.8968 7.50008 15.0833 7.31353 15.0833 7.08341C15.0833 6.8533 14.8968 6.66675 14.6667 6.66675C14.4365 6.66675 14.25 6.8533 14.25 7.08341C14.25 7.31353 14.4365 7.50008 14.6667 7.50008Z" />
        <path d="M8.91667 7.50008C9.14679 7.50008 9.33333 7.31353 9.33333 7.08341C9.33333 6.8533 9.14679 6.66675 8.91667 6.66675C8.68655 6.66675 8.5 6.8533 8.5 7.08341C8.5 7.31353 8.68655 7.50008 8.91667 7.50008Z" />
    </svg>
);

export default Waze;
